export enum StepState {
	DONE = 'done',
	IN_PROGRESS = 'in_progress',
	READY_TO_COMPLETE = 'ready_to_complete',
}
